import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Box, IconButton } from '@mui/material'
import MessageIcon from '../../assets/icons/Documents/Document.svg'

const styles = {
    tempPasswordBox: {
        display: 'flex',
        gap: 1,
    },
}

interface Props {
    isLoading?: boolean
    confirmAction: () => void
}

const SendWelcomeMessageDialog: React.FC<Props> = ({
    confirmAction,
    isLoading = false,
}) => {
    const { formatMessage } = useIntl()
    const [open, setOpen] = React.useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Box sx={{ ml: 1 }}>
            <Box sx={styles.tempPasswordBox}>
                <IconLockButton
                    disabled={isLoading}
                    onClick={() => handleClickOpen()}
                >
                    <img
                        src={MessageIcon}
                        alt="edit"
                    />
                </IconLockButton>
            </Box>

            <Dialog
                maxWidth={'sm'}
                fullWidth
                open={open}
                onClose={handleClose}
            >
                <DialogTitle id="responsive-dialog-title">
                    {formatMessage({ id: 'send_welcome_message' })}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        {formatMessage(
                            { id: 'send_welcome_message_confirm_text' },
                        )}
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ m: 2 }}>
                    <Button onClick={handleClose}>
                        {formatMessage({ id: 'cancel' })}
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => {
                            confirmAction()
                            handleClose()
                        }}
                    >
                        {formatMessage({ id: 'yes' })}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default SendWelcomeMessageDialog

const IconLockButton = styled(IconButton)`
    display: flex;
    gap: 4px;
    width: fit-content;
`
